import React from 'react'

import type { IEmptyProps } from 'components/uiKit/Empty'
import Table from 'components/uiKit/Table'
import type { FinderItem } from 'store/models'

import type { Paths } from '../types'
import { columnsConfig, columnsConfigModal } from './config'

export const FINDER_PAGE_NAME = 'finderPage'

interface IFinderTableProps {
  data: FinderItem[]
  onChangeSelection?: (radio: FinderItem[]) => void
  total: number
  selectedItems: FinderItem[]
  loading: boolean
  empty?: IEmptyProps
  clearQuery: () => void
  paths: Paths
  fetchMore?: () => Promise<unknown>
  onClickItem: (item: FinderItem) => void
  isModal?: boolean
  checkbox?: boolean
}

const FinderTable: React.FC<IFinderTableProps> = ({
  data,
  onChangeSelection,
  onClickItem,
  total,
  selectedItems,
  loading,
  clearQuery,
  empty,
  paths,
  isModal,
  checkbox,
}) => {
  const columnConfig = isModal ? columnsConfigModal(onClickItem) : columnsConfig(paths, clearQuery)
  return (
    <Table
      checked={checkbox}
      columns={columnConfig}
      dataSource={data}
      empty={empty}
      loading={loading}
      name={FINDER_PAGE_NAME}
      onChangeSelection={onChangeSelection}
      selectedItems={selectedItems}
      total={total}
      pagination
    />
  )
}

export default FinderTable
